module.exports = __webpack_public_path__ + "img/logo.5f5a01c6.png";